"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var _getAddressString = _interopRequireDefault(require("./getAddressString"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function getFormattedLocations(locations) {
  if ((0, _lodash.isEmpty)(locations)) {
    return [];
  }
  return locations.map(function (location) {
    var latLng = {
      lat: (0, _lodash.get)(location, 'attributes.latitude', ''),
      lng: (0, _lodash.get)(location, 'attributes.longitude', '')
    };
    return {
      address: (0, _getAddressString["default"])(location.attributes),
      id: (0, _lodash.get)(location, 'id', ''),
      latLng: latLng
    };
  });
}
var _default = exports["default"] = getFormattedLocations;